import * as React from "react";
import { ProfileSelectors } from "@grandvisionhq/my-account";
import { useDispatch, useSelector } from "@grandvisionhq/state";
import { ShippingObjectTypes } from "../../../../../../../../state.js";
import { updateShippingDetails } from "../../../../../../../../StepShipping/StepShipping/actions.js";
import { getExpressCheckoutFormData } from "../../../../../../../../StepShipping/StepShipping/selectors.js";
/* empty css                                  */
import { CheckoutForm } from "../../../../../../../../components/Forms/components/Forms/CheckoutForm.js";
import { FormFieldsWithCart } from "../../../../../../../../components/FormFieldsWithCart/components/FormFieldsWithCart/FormFieldsWithCart.js";
import { useIsFormSlotAvailable } from "../../../../../../../../slots/forms/slots/forms/form-context.js";
const ExpressCheckoutFormContainer = () => {
  const dispatch = useDispatch();
  const isExpressFormAvailable = useIsFormSlotAvailable(ShippingObjectTypes.ExpressCheckout);
  const expressCheckoutInitialData = useSelector(getExpressCheckoutFormData);
  const profileDateOfBirthValue = useSelector(ProfileSelectors.getFormData)?.personalDetails?.dateOfBirth;
  const initialExpressCheckoutData = React.useMemo(() => {
    const expressCheckoutDOBKey = "express-checkout-dob";
    const dobFormData = expressCheckoutInitialData?.[expressCheckoutDOBKey];
    if (dobFormData && profileDateOfBirthValue) {
      return {
        ...expressCheckoutInitialData,
        [expressCheckoutDOBKey]: {
          ...dobFormData,
          value: dobFormData.value || profileDateOfBirthValue
        }
      };
    }
    return expressCheckoutInitialData;
  }, [expressCheckoutInitialData, profileDateOfBirthValue]);
  const handleChange = React.useCallback(
    (formData) => {
      dispatch(updateShippingDetails({ form: formData }));
    },
    [dispatch]
  );
  if (!isExpressFormAvailable) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", { className: "express-checkout-form-container" }, /* @__PURE__ */ React.createElement(
    CheckoutForm,
    {
      formName: "expressCheckout",
      "data-t": "expressCheckout",
      initialFormState: initialExpressCheckoutData,
      onChange: handleChange
    },
    /* @__PURE__ */ React.createElement(FormFieldsWithCart, { formName: ShippingObjectTypes.ExpressCheckout })
  ));
};
export {
  ExpressCheckoutFormContainer
};
//# sourceMappingURL=ExpressCheckoutFormContainer.js.map
